import { render, staticRenderFns } from "./ResetPassword.success.form.vue?vue&type=template&id=5067a162&scoped=true&lang=pug&"
import script from "./ResetPassword.success.form.vue?vue&type=script&lang=ts&"
export * from "./ResetPassword.success.form.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPassword.success.form.vue?vue&type=style&index=0&id=5067a162&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067a162",
  null
  
)

export default component.exports